import React from "react";

import AddShop from "commonComponents/addShop/AddShop";

/**
 * SuperAddShop - the super admin route for creating a shop.
 *
 * AddShop renders its own page shell for this variant, so there is
 * nothing to add here beyond naming which one it is. The `theme` prop
 * this used to pass picked between three hard-coded colour maps that
 * no longer exist.
 */
const SuperAddShop = () => <AddShop type="superAdmin" />;

export default SuperAddShop;
